/**
 * Small helpers that keep the redaction UI state consistent in every invoice view.
 * The goal is to keep the modal, spinner, and disabled controls aligned while the API request runs.
 */

/**
 * Close the modal immediately and move feedback to the redactor area.
 *
 * @returns {{showConfirmRedactProcess: boolean, redactionProcessing: boolean}}
 */
export function getRedactionProcessStartState() {
  return {
    showConfirmRedactProcess: false,
    redactionProcessing: true,
  };
}

/**
 * Stop the in-context feedback after a successful redaction request finishes.
 *
 * @returns {{redactionProcessing: boolean, redactSelection: Array}}
 */
export function getRedactionProcessSuccessState() {
  return {
    redactionProcessing: false,
    redactSelection: [],
  };
}

/**
 * Stop the in-context feedback and reuse the existing translated error message.
 *
 * @param {(key: string) => string} readTranslation
 * @returns {{redactionProcessing: boolean, savingError: string}}
 */
export function getRedactionProcessErrorState(readTranslation) {
  return {
    redactionProcessing: false,
    savingError: readTranslation('redaction.redaction_error'),
  };
}

/**
 * Keep all redaction entry points disabled while the request is running.
 *
 * @param {Object} params
 * @param {boolean} params.hasSelectableId
 * @param {boolean} params.isLocked
 * @param {boolean} params.isProcessing
 * @returns {boolean}
 */
export function isRedactionSelectionDisabled({ hasSelectableId, isLocked = false, isProcessing = false }) {
  return !hasSelectableId || isLocked || isProcessing;
}

/**
 * Disable the main redact action when the invoice or the redaction flow cannot accept new requests.
 *
 * @param {Object} params
 * @param {boolean} params.isLocked
 * @param {boolean} params.isFinalized
 * @param {boolean} params.isProcessing
 * @param {boolean} params.isXpenseInvoice
 * @returns {boolean}
 */
export function isRedactActionDisabled({ isLocked = false, isFinalized = false, isProcessing = false, isXpenseInvoice = false }) {
  return isLocked || isFinalized || isProcessing || isXpenseInvoice;
}
